// eslint-disable-next-line no-restricted-imports
import {toggle} from 'opticks'

import {getExperimentsBySubstring} from '../utils'

const BOVIO_EXPERIMENT_SUBSTRING = 'bovioExperiment'

export const collectBovioVariationsParam = (
  dataFileExperiments: string[] = []
) => {
  return (
    //in case we want to combine with sapi4eva we don't match the prefix, but substring
    getExperimentsBySubstring(BOVIO_EXPERIMENT_SUBSTRING, dataFileExperiments)
      // Opticks throws "user id is not set" until `InitializeABTesting` runs
      // `Opticks.setUserId`. Callers of this selector (`getBovioApiKey`) run
      // during first render and from the analytics middleware, so the throw
      // escapes and the error boundary replaces the page. Treat the
      // unidentified state as "no decision yet" and fall back to the base
      // profile key, the same way `useCapabilityContext` does (sc-185936).
      .map(key => {
        try {
          return toggle(key, null, key)
        } catch {
          return null
        }
      })
      .filter(Boolean) || []
  )
}
